<div
  class="bg-white container-fluid position-relative py-3 overflow-x-clip"
  style="margin-top: -57px"
>
  <svg
    preserveAspectRatio="none"
    class="main-section-home-svg position-absolute start-0 w-100"
    viewBox="0 0 1595 197"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    fill="white"
  >
    <path
      d="M1310.47 110.038C1363.08 107.561 1454.12 104.515 1533.36 124.425C1553.59 129.286 1577.82 137.968 1594.82 150.317L1594.82 222.424L-5.22662 222.424L-5.22659 90.1601C35.4514 71.3813 81.0696 54.2379 132.832 39.687C339.948 -18.5357 474.389 11.5859 582.345 36.5655C628.282 49.0675 676.449 56.5073 725.88 58.7358C810.326 57.5247 895.863 45.0391 979.708 21.685C1044.66 5.22551 1095.79 -6.79795 1140.77 5.8709C1157.26 11.0807 1171.96 19.3644 1183.98 30.2357C1196.01 41.1069 1205.12 54.3464 1210.79 69.1769C1215.12 82.6739 1223.03 94.6486 1233.93 104.168C1244.79 109.425 1257.35 111.935 1270.45 111.468C1282.56 111.245 1296.04 110.638 1310.47 110.038Z"
      fill="var(--globalvar-basecolor-white-bg)"
    ></path>
  </svg>

  <!-- <div class="ocean">
      <div class="wave"></div>
      <div class="wave"></div>
    </div> -->

  <div class="row">
    <div class="col-md-12 d-flex flex-column align-items-center">
      <p
        class="fw-bolder fs-1 lh-lg m-0 text-black text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{ "The success story starts here" | translate }}
      </p>
      <p
        class="fs-5 text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="500"
        data-aos-offset="50"
        data-aos-once="true"
      >
        {{
          "You are in the right place to move forward towards the goals of achieving your goals"
            | translate
        }}
      </p>
    </div>
    <div
      class="col-md-4 d-flex gap-3 flex-column align-items-center py-5 px-5 text-center mt-2 text-black"
      *ngFor="let statistic of statistics; let i = index"
      data-aos="fade-up"
      data-aos-duration="1000"
      [attr.data-aos-delay]="500 + 500 * (i + 1)"
      data-aos-offset="50"
      data-aos-once="true"
    >
      <img [src]="statistic.photo" alt="" height="200px" />
      <p class="fs-3 text-black-50 lh-1 text-center">
        {{ statistic.title | translate }}
      </p>
    </div>
  </div>
</div>
